import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "list"]

  filter() {
    const query = this.normalize(this.inputTarget.value.toLowerCase().trim())
    const items = this.listTarget.querySelectorAll("[data-recipe-name]")

    items.forEach(item => {
      const name = this.normalize(item.dataset.recipeName)
      if (query === "" || name.includes(query)) {
        item.closest("form").style.display = ""
      } else {
        item.closest("form").style.display = "none"
      }
    })
  }

  normalize(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  }
}
